import { useMemo } from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { fundColor, FUND_META } from "@/lib/finance";
import { usd } from "@/lib/format";

export function AllocationDonut({ data = [] }) {
  const total = data.reduce((s, d) => s + d.value, 0);
  const sorted = useMemo(() => [...data].sort((a, b) => b.value - a.value), [data]);
  if (!total) return <p className="text-sm text-muted-foreground py-10 text-center" data-testid="allocation-empty">Add holdings to see your allocation.</p>;
  return (
    <div className="grid sm:grid-cols-[180px_1fr] lg:grid-cols-1 xl:grid-cols-[170px_1fr] gap-4 items-center" data-testid="allocation-donut">
      <div className="h-44">
        <ResponsiveContainer>
          <PieChart>
            <Pie data={data} dataKey="value" nameKey="name" innerRadius="62%" outerRadius="95%" paddingAngle={2} stroke="none">
              {data.map((d) => <Cell key={d.name} fill={fundColor(d.name)} />)}
            </Pie>
            <Tooltip formatter={(v) => usd(v)} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <ul className="space-y-2">
        {sorted.map((d) => (
          <li key={d.name} className="flex items-center justify-between text-sm" data-testid={`allocation-row-${d.name}`}>
            <span className="flex items-center gap-2"><span className="h-2.5 w-2.5 rounded-sm" style={{ background: fundColor(d.name) }} />{FUND_META[d.name]?.name || d.name}</span>
            <span className="font-mono-num text-slate-700 dark:text-slate-300">{((d.value / total) * 100).toFixed(1)}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
